// from general.js
/* global dcAnalytics */
// from JSP?
/* global partnerName eligibleForAutoDonationMatch */

import { parseInteger } from '../utils/numberUtils';

const matchStateDefault = function () {
    $('.js-show-when-give-open').hide();
    $('.js-show-when-give-closed').show();
};

const matchStateOpen = function () {
    $('.js-show-when-give-open').show();
    $('.js-show-when-give-closed').hide();
};

export const toggleDonateOptions = function () {
    if ($('#donateOptions').hasClass('on')) {
        $('#donateOptions').removeClass('on')
            .css({ 'min-height': '0px', height: '0px' });
        $('#donateBar').show();
        if ($('.has-match').length > 0) {
            matchStateDefault();
        }
    } else {
        $('#donateOptions').addClass('on')
            .css({ 'min-height': $('#donateOptions')[0].scrollHeight + 'px', height: 'auto' });
        $('.js-mobile-donation-box').css({ height: 'auto' });
        $('.js-donation-wrapper').css({ height: 'auto' });
        $('#close-give').show();
        $('#donateBar').hide();
        if ($('.has-match').length > 0) {
            matchStateOpen();
        }
    }
};

export const populateDonateOptions = function (formId, amountName) {
    if ($('#donateOptions').length === 0) {
        $('#donateBar').before('<div id="donateOptions"></div>');
        $('body').trigger('donateOptionsAdded');
    }
    if ($('#donateOptions #' + formId).length === 0) {
        $('#donateOptions').append($('#' + formId));
    }
    if ($('#donateOptions .suggestedAmount').length === 0) {
        $('#donateOptions').prepend(getSuggestedDonateAmounts());
        $('#donateOptions').on('click.suggestedAmount', '.suggestedAmount', function () {
            $('#donateOptions input[name=' + amountName + ']').val($(this).text());
            // potentially defined in Optimizely
            /* global isOptimizelyTestMultiProjectGiving */
            if (typeof isOptimizelyTestMultiProjectGiving === 'undefined' || !isOptimizelyTestMultiProjectGiving()) {
                $('#donateOptions form').submit();
            }
        });

        addEventGATrackingToSuggestedDonateAmounts();
    }
};

export const addEventGATrackingToSuggestedDonateAmounts = function () {
    $('#donateOptions .js-suggested-amount').on('click', function () {
        dcAnalytics.trackEventGA([pageName, 'give expanded', 'suggested amount button']);
    });
    $('#donateOptions .js-complete-project').on('click', function () {
        dcAnalytics.trackEventGA([pageName, 'give expanded', 'complete button']);
    });
    $('#donateOptions .js-enter-custom-amount').on('click', function (e) {
        e.preventDefault();
        openAnotherAmountForm();
        dcAnalytics.trackEventGA([pageName, 'give expanded', 'another amount link']);
    });
};

function fixDonateOptionsHeight() {
    $('#donateOptions').css({ 'min-height': $('#donateOptions')[0].scrollHeight + 'px', height: 'auto' });
}

export const addDonateOptionsClose = function () {
    $('#donateOptions .suggestedAmountHolder .other-actions').append('<div class="close">cancel</div>');
    $('#donateOptions .close').on('click.close', function () {
        dcAnalytics.trackEventGA([pageName, 'give button cancel']);
        toggleDonateOptions();
    });
};

function openAnotherAmountForm() {
    $('#donateOptions form').show();
    $('#donateOptions form').addClass('desktop-override');
    $('.enterAnotherAmount').hide();
    $('#donateOptions .close').hide();
    $('#donateOptions form').append('<div class="close">cancel</div>');
    $('#donateOptions form .close').on('click.close', function () {
        dcAnalytics.trackEventGA([pageName, 'give button cancel']);
        toggleDonateOptions();
    });
    $('#amount').focus();
    fixDonateOptionsHeight();
}

export const getSuggestedDonateAmounts = function (maxSuggested) {
    const suggested = [25, 50, 100, 200];
    let suggestedAmounts = '<div class="suggestedAmountHolder">';
    // the following if-clause is only for the project page
    if (typeof eligibleForAutoDonationMatch !== 'undefined' && eligibleForAutoDonationMatch) {
        suggestedAmounts += '<div class="dyi-explanation">Your donation to this project will be matched thanks to ' + partnerName + '.</div>';
    }

    suggestedAmounts += '<div class="anchored">';

    for (let i = 0; i < suggested.length; i++) {
        if (maxSuggested == null || parseInteger(maxSuggested) > suggested[i]) {
            suggestedAmounts += '<div class="button-secondary suggestedAmount js-suggested-amount">' + suggested[i] + '</div>';
        }
    }

    suggestedAmounts += '</div>';
    suggestedAmounts += '<div class="complete">';

    if (maxSuggested != null && parseInteger(maxSuggested) > 0) {
        suggestedAmounts += '<div class="button-secondary suggestedAmount completeAmount js-complete-project">' + maxSuggested + '</div>';
    }

    suggestedAmounts += '</div>';

    suggestedAmounts += '<div class="other-actions">';
    suggestedAmounts += '<a href="#" class="enterAnotherAmount js-enter-custom-amount">or give another amount</a>';
    suggestedAmounts += '</div>';

    suggestedAmounts += '</div>';

    return suggestedAmounts;
};
